import { resolveLink } from "utils/link-resolver";

import PageTemplate from "templates/page";
import IndexPage from "pages/index";

/**
 * Shared configuration for `gatsby-plugin-prismic-previews`. Passed once to
 * `<PrismicPreviewProvider>` (in gatsby-browser.js / gatsby-ssr.js).
 *
 * - `linkResolver` must match the one given to `gatsby-source-prismic` in
 *   gatsby-config.js so preview URLs resolve identically to the built site.
 * - `componentResolver` maps a Prismic document type to the page component used
 *   to render an *unpublished* preview (via `withPrismicUnpublishedPreview` on
 *   the 404 page).
 */
export const repositoryConfigs = [
  {
    repositoryName: "topazwebsite",
    linkResolver: (doc) => resolveLink(doc),
    componentResolver: {
      page: PageTemplate,
      homepage: IndexPage,
    },
  },
];
